import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconBrowserTabs: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="browser-tabs, tab-groups"><path d="M21.25 4.75H2.75V19.25H21.25V4.75Z" stroke="currentColor" strokeWidth="1.5"/><path d="M5.00024 7.75L12.0002 7.75" stroke="currentColor" strokeWidth="1.5"/><path d="M16.4999 7.75L19 7.75" stroke="currentColor" strokeWidth="1.5"/><path d="M12.9998 7.75L15.5 7.75" stroke="currentColor" strokeWidth="1.5"/></CentralIconBase>;
};

export default IconBrowserTabs;
